var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLightBulb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3466 1.2154V9.4559C13.3466 10.1214 13.8911 10.666 14.5566 10.666H22.7729C23.5474 10.666 24.1282 9.95203 23.9588 9.18969C22.9302 4.63987 19.3606 1.0581 14.8228 0.0295462C14.0605 -0.139862 13.3466 0.440966 13.3466 1.2154ZM10.8905 1.21626V22.5617C10.8905 23.3361 10.1766 23.917 9.42636 23.7476C4.0174 22.5375 0 17.6852 0 11.889C0 6.0928 4.0174 1.24046 9.42636 0.0304032C10.1766 -0.139005 10.8905 0.441823 10.8905 1.21626ZM13.3466 22.5606V14.3201C13.3466 13.6546 13.8911 13.1101 14.5687 13.098H22.785C23.5474 13.098 24.1403 13.824 23.9709 14.5743C22.9423 19.1241 19.3727 22.718 14.8228 23.7465C14.0605 23.9159 13.3466 23.3351 13.3466 22.5606Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightBulb);
export default __webpack_public_path__ + "static/media/light-bulb.06ddf201.svg";
export { ForwardRef as ReactComponent };